import { render, staticRenderFns } from "./myPoster.vue?vue&type=template&id=0f00ffc4&scoped=true&"
import script from "./myPoster.vue?vue&type=script&lang=js&"
export * from "./myPoster.vue?vue&type=script&lang=js&"
import style0 from "./myPoster.vue?vue&type=style&index=0&lang=less&"
import style1 from "./myPoster.vue?vue&type=style&index=1&id=0f00ffc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f00ffc4",
  null
  
)

export default component.exports